export const RESET_SPONSORSHIP = "RESET_SPONSORSHIP"
export const API_GET_KEEPER_SPONSORSHIP = "API_GET_KEEPER_SPONSORSHIP"
